<template>
  <div id="app">
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'app',
    components: {
    }
  }

</script>

<style lang="scss">
  body {
    margin: 0px;
    padding: 0px;
    /*background: url(assets/bg1.jpg) center !important;
      background-size: cover;*/
    background: #F2F6FC;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
  }

  #app {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
  }

  .el-submenu [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
  }

  .el-menu-item [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
  }

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    //border:1px solid #dfe6ec;
    margin: 10px 0px;
    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  ::-webkit-scrollbar
  {
    width: 6px;
    height: 6px;
    background-color: rgba(96,204,136,0.2);
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track
  {
    background-color: rgba(96,204,136,0.2);
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb
  {
    border-radius: 10px;
    background-color: #1A7EBA;
  }
  //全局滚动条颜色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1A7EBA!important;
  }
  //全区tab框切换颜色
  .el-tabs__item.is-active{
    color:#1A7EBA!important;
  }
  //全区tab框切换颜色
  .el-tabs__active-bar{
    background-color: #1A7EBA!important;
  }
  .el-tabs__item:hover{
    color:#35B178!important;
  }
  //输入框获得焦点变绿
  .el-input.is-active .el-input__inner, .el-input__inner:focus{
    border-color:#1A7EBA!important;
  }
  //多行输入框获得焦点变绿
  .el-textarea__inner.is-active .el-textarea__inner, .el-textarea__inner:focus{
    border-color:#1A7EBA!important;
  }
  //分页样式
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    border-radius: 100%!important;
  }
  //定义按钮字体颜色
  .el-button--text{
    color:#1A7EBA!important;
  }
  //特殊无边框日期样式
  .borderNone{
    width: 127px!important;
    .el-input__inner{
      border: none!important;
    }
  }
  //查看文件
  .el-upload-list__item-name{
    color: #409EFF!important;
  }
  //提示文字
  .el-upload__tip{
    color: #F56C6C!important;
  }
  .self-input-width{
    width: 380px!important;
  }
  .self-input-width-min{
    width: 250px!important;
  }
  .red-span{
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #35B178!important;
    border-color: #35B178!important;
  }
  //登录页滑块
  .slide-verify-slider{
    margin-top: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue